import React, { useCallback } from 'react';
import { PLAN_TYPE_FILTERS } from '../../config/agent.config';
import type { PlanFiltersState } from '../../types/agent.types';

interface PlanFiltersProps {
  filters: PlanFiltersState;
  onFiltersChange: (filters: Partial<PlanFiltersState>) => void;
}

export const PlanFilters: React.FC<PlanFiltersProps> = ({
  filters,
  onFiltersChange,
}) => {
  const handleSearchChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onFiltersChange({ search: e.target.value });
    },
    [onFiltersChange]
  );

  return (
    <div className="agent-filters">
      <div className="agent-filters-row">
        {/* Type filter chips */}
        <div className="agent-filter-chips">
          {PLAN_TYPE_FILTERS.map((filter) => {
            const isActive = filter.id === 'all'
              ? !filters.planType
              : filters.planType === filter.types.join(',');

            return (
              <button
                key={filter.id}
                className={`agent-chip${isActive ? ' agent-chip--active' : ''}`}
                onClick={() =>
                  onFiltersChange({
                    planType: filter.id === 'all' ? null : filter.types.join(','),
                  })
                }
              >
                {filter.label}
              </button>
            );
          })}
        </div>

        {/* Search */}
        <div className="agent-search-wrap">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <input
            type="text"
            className="agent-search-input"
            placeholder="N° affaire..."
            value={filters.search}
            onChange={handleSearchChange}
          />
        </div>
      </div>
    </div>
  );
};
